import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'otSumInArray' })
export class SumInArrayPipe implements PipeTransform {
  transform(items: any[], attr: string): number {
    return items.reduce((a, b) => parseFloat(a) + parseFloat(b[attr]), 0);
  }
}
